import { AxiosResponse } from "axios"
import { getData, postData } from "./apiInstance"
import { CheckUniquiAadharPanPayloadType } from "../commonTypes/usersProfileTypes"
import { getCSRFToken } from "../utils/commonFunctions"

export async function addUserApi(data: any): Promise<AxiosResponse> {

  let {token,profileData}= data
  
  return await postData(`finac/user/add`, {...profileData}, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token":  getCSRFToken()
    }
  })
};

export async function updateProfileApi(data: any): Promise<AxiosResponse> {

  let {token,profileData,status}= data
  
  return await postData(`finac/user/profile/update`, {...profileData,status}, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token":  getCSRFToken()
    }
  })
};


export async function checkUniqueAadhaarNoApi(data: CheckUniquiAadharPanPayloadType): Promise<AxiosResponse> { 
  const {token,operation,role,user_id,aadhaar}=data;
  const finalParams={
    operation,
    aadhaar: aadhaar,
    role,
    user_id
  }

  return await getData(`master-module/aadhaar-pan/unique/check`,{
    params:{
      ...finalParams
    },
    headers:{
    "Content-Type":"application/json",
    "user-token":token
    }
  })

}

export async function checkUniquePanNoApi(data: CheckUniquiAadharPanPayloadType): Promise<AxiosResponse> { 
  const {token,operation,role,user_id,pan}=data;
  const finalParams={
    operation,
    pan,
    role,
    user_id
  }

  return await getData(`master-module/aadhaar-pan/unique/check`,{
    params:{
      ...finalParams
    },
    headers:{
    "Content-Type":"application/json",
    "user-token":token
    }
  })

}

export async function checkUniquePassportNoApi(data: CheckUniquiAadharPanPayloadType): Promise<AxiosResponse> { 
  const {token,operation,role,user_id,passport}=data;
  const finalParams={
    operation,
    passport,
    role,
    user_id
  }

  return await getData(`master-module/aadhaar-pan/unique/check`,{
    params:{
      ...finalParams
    },
    headers:{
    "Content-Type":"application/json",
    "user-token":token
    }
  })

}


export async function checkUniqueUanApi(data: CheckUniquiAadharPanPayloadType): Promise<AxiosResponse> { 
  const {token,operation,role,user_id,uan_no}=data;
  const finalParams={
    operation,
    uan_no,
    role,
    user_id
  }

  return await getData(`master-module/aadhaar-pan/unique/check`,{
    params:{
      ...finalParams
    },
    headers:{
    "Content-Type":"application/json",
    "user-token":token
    }
  })

}
